import React from 'react';
import { Router } from './router.jsx';
import { ThemeProvider } from './components/ThemeProvider.jsx';

export default function App() {
  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
}
